import { render, staticRenderFns } from "./AdminUserDelete.vue?vue&type=template&id=0af19f2f&scoped=true"
import script from "./AdminUserDelete.vue?vue&type=script&lang=js"
export * from "./AdminUserDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminUserDelete.vue?vue&type=style&index=0&id=0af19f2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af19f2f",
  null
  
)

export default component.exports